import { Payment } from '@views/Invoice/invoiceTypes';
import moment from 'moment';

export function TransactionSummary({ payment }: { payment: Payment }) {
  return (
    <div className='bg-white rounded-lg shadow-sm border border-gray-200 p-6 max-w-2xl'>
      <h3 className='text-lg font-semibold text-gray-900 mb-6'>
        Transaction Summary
      </h3>

      <dl className='space-y-4'>
        <div className='flex flex-col sm:flex-row sm:justify-between gap-1'>
          <dt className='text-sm font-medium text-gray-500'>Reference</dt>
          <dd className='text-sm text-gray-900 font-mono'>
            {payment.paymentReference}
          </dd>
        </div>

        <div className='flex flex-col sm:flex-row sm:justify-between gap-1'>
          <dt className='text-sm font-medium text-gray-500'>
            Transaction Date
          </dt>
          <dd className='text-sm text-gray-900'>
            {moment(payment.createdAt).format('DD MMM YYYY')}
          </dd>
        </div>

        {/* TODO: Add status once Yapily web socket is implemented */}
        {/* <div className='flex flex-col sm:flex-row sm:justify-between gap-1'>
          <dt className='text-sm font-medium text-gray-500'>Status</dt>
          <dd className='text-sm text-gray-900'>{payment.status}</dd>
        </div> */}
      </dl>

      <div className='mt-6 pt-4 border-t border-gray-200'>
        <div className='flex justify-between items-center'>
          <span className='text-base font-semibold text-gray-900'>Total</span>
          <span className='text-xl font-bold text-gray-900'>
            {payment.currencySymbol}
            {payment.amount.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
}
